import { localize } from 'monaco-editor/esm/vs/nls.js';
const ADD_ROOT_FOLDER_COMMAND_ID = 'addRootFolder';
const ADD_ROOT_FOLDER_LABEL = { value: ( localize('addFolderToWorkspace', "Add Folder to Workspace...")), original: 'Add Folder to Workspace...' };
const SET_ROOT_FOLDER_COMMAND_ID = 'setRootFolder';
const PICK_WORKSPACE_FOLDER_COMMAND_ID = '_workbench.pickWorkspaceFolder';
export { ADD_ROOT_FOLDER_COMMAND_ID, ADD_ROOT_FOLDER_LABEL, PICK_WORKSPACE_FOLDER_COMMAND_ID, SET_ROOT_FOLDER_COMMAND_ID };
